export default "__VITE_ASSET__DqK7ugNI__"